import { Component, OnInit, inject } from '@angular/core'
import { BndLoading } from '@bonduelle-it/storybook'
import { AuthService } from '../services'
@Component({
  selector: 'app-login',
  imports: [BndLoading],
  template: '<bnd-loading />',
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService)

  ngOnInit() {
    this.authService.redirectToLogin()
  }
}
